/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API48490Item {
  
  /**  */
  id?: number;
  
  /** 业务编号 */
  bizNo?: string;
  
  /** 评论类型（biz_plan：商业计划书；project_plan：项目计划书） */
  commentType?: string;
  
  /** 评论内容 */
  comment?: string;
  
  /** 引用内容 */
  quote?: string;
  
  /** 字段模块字段 */
  dataTitle?: string;
  
  /** 引用内容前端样式id */
  quoteId?: string;
  
  /** 创建者 */
  creator?: string;
  
  /** 创建者名称 */
  creatorName?: string;
  
  /** 创建人头像 */
  creatorAvatar?: string;
  
  /** 评论时间 */
  createdAt?: any;
  
};
    
  



export interface API48490Req {
  
  /** 业务编号 */
  bizNo?: string;
  /** 评论类型（biz_plan：商业计划书；project_plan：项目计划书） */
  commentType?: string;
};



export interface API48490Res {
  /** T  */
  list?: API48490Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 48490 查看评论列表

export interface IUsePostAPI48490Return {
  /** 查看评论列表: 接口请求状态 */
  isAPI48490Loading: boolean;
  /** 查看评论列表: 接口请求返回数据 */
  dataAPI48490: API48490Res;
  /**  查看评论列表: 接口数据请求方法 */
  fetchAPI48490Data:  (inputs: API48490Req, config?: YWRequestConfig) => Promise<API48490Res>;
  /** 查看评论列表: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48490 = ():IUsePostAPI48490Return => {
  let isMount = true;
  const [isAPI48490Loading, setIsAPI48490Loading] = useState(false);
  const [dataAPI48490, setDataAPI48490] = useState<API48490Res>({} as API48490Res);
  const requestUrl = `${basePath}/corp-admin/project/comment/list`;

  const fetchAPI48490Data = async (inputs: API48490Req, config?: YWRequestConfig): Promise<API48490Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48490Req>) || {}) as API48490Req;
    
  
    if ( isMount ) {
      setIsAPI48490Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48490Res>(`${basePath}/corp-admin/project/comment/list`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48490(res || {} as API48490Res);
        setIsAPI48490Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48490Loading(false);
      }
      return false as unknown as API48490Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48490Loading,
    dataAPI48490,
    fetchAPI48490Data,
    requestUrl,
  }
}

